import React, { Component, HTMLProps } from "react";
import TextMask from "react-text-mask";
import { fullWidthToHalfWidth } from "checkout/ts/utils/numbers";
import { isChrome, isWindows } from "common/utils/browser";

const CARD_EXP_MASK: (string | RegExp)[] = [/[0-9０-９]/, /[0-9０-９]/, "/", /[0-9０-９]/, /[0-9０-９]/];

export type CardExpInputProps = Omit<HTMLProps<React.InputHTMLAttributes<string>>, "onChange"> & {
    showPlaceholder?: boolean;
    onChange?: (value: string) => void;
};

export class CardExpInput extends Component<CardExpInputProps> {
    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value: eventValue } = event.target as HTMLInputElement;
        const skipAutoFormatting = isChrome() && isWindows();
        this.props.onChange?.(skipAutoFormatting ? eventValue : fullWidthToHalfWidth(eventValue));
    };

    render() {
        const { value = "", showPlaceholder = true, ...props } = this.props;
        const year = new Date().getFullYear().toString().slice(-2);

        const skipAutoFormatting = isChrome() && isWindows();
        const disableFormattingOnCapture = (event) => {
            event.stopPropagation();
            event.preventDefault();
            return false;
        };

        return (
            <TextMask
                {...props}
                autoComplete="cc-exp"
                placeholder={showPlaceholder ? `12/${year}` : undefined}
                type="tel"
                maxLength="5"
                pattern="[0-9０-９]*"
                inputMode={skipAutoFormatting ? "search" : "numeric"}
                guide={false}
                keepCharPositions={false}
                mask={CARD_EXP_MASK}
                placeholderChar={"\u2000"}
                onChange={this.handleChange}
                onInputCapture={skipAutoFormatting ? disableFormattingOnCapture : undefined}
                value={skipAutoFormatting ? String(value) : fullWidthToHalfWidth(String(value))}
            />
        );
    }
}
